import { render, staticRenderFns } from "./honorRoll.vue?vue&type=template&id=e8176f02&scoped=true"
import script from "./honorRoll.vue?vue&type=script&lang=js"
export * from "./honorRoll.vue?vue&type=script&lang=js"
import style0 from "./honorRoll.vue?vue&type=style&index=0&id=e8176f02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8176f02",
  null
  
)

export default component.exports